













import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import barChart from "../charts/barReactive.vue";
import { completionChartOptions } from "../../utils";

@Component({
  components: {
    barChart
  }
})
export default class LessonCompletionBarChart extends Vue {
  @Prop() private data!: any;
  private labels: string[] = [];
  private datacollection: any = {};
  private options: any = completionChartOptions;

  private created() {
    this.options.scales.xAxes[0].barThickness = 33;
    this.options.tooltips.callbacks.beforeLabel = (tooltipItem: any) => {
      if (this.labels[tooltipItem.index]) {
        return this.labels[tooltipItem.index];
      }
      return "Lesson Title";
    };
    this.datacollection = this.genDatacollection();
  }

  private genDatacollection() {
    let data = [0, 0, 0];
    if (this.data && this.data.Exercises) {
      data = [];
      this.labels = [];
      for (let i = 0; i < this.data.Exercises.length; ++i) {
        data.push(Math.round(this.data.Exercises[i].CompletionRate * 100));
        this.labels.push(this.data.Exercises[i].Title);
      }
    }

    let emptyData = [];
    for (let i = 0; i < data.length; ++i) {
      emptyData.push(100 - data[i]);
    }
    let datacollection = {
      labels: data.map((_, i) => `Ex ${String(i + 1)}`),
      datasets: [
        {
          data,
          backgroundColor: "#38d17a"
        },
        {
          data: emptyData,
          backgroundColor: "#fafafa"
        }
      ]
    };
    return datacollection;
  }

  @Watch("data")
  private onDataChanged() {
    this.datacollection = this.genDatacollection();
  }
}
